<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { initLayoutThemeRoot } from '@/utils/layoutTheme'

export default {
  name: 'App',
  mounted() {
    initLayoutThemeRoot()
  }
}
</script>

<style>
/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  /* Firefox：浅灰细滚动条 */
  scrollbar-width: thin;
  scrollbar-color: rgba(144, 147, 153, 0.3) transparent;
}

html,
body {
  font-family: Arial, sans-serif;
  font-size: 16px; /* 基准字体大小，1rem = 16px */
  height: 100%;
  overflow: hidden;
  color: #303133;
}

#app {
  height: 100%;
  overflow: hidden;
}

/* 响应式字体大小 */
@media screen and (max-width: 1200px) {
  html {
    font-size: 14px;
  }
}

@media screen and (max-width: 768px) {
  html {
    font-size: 12px;
  }
}
/* 时间选择器适配移动/ */
@media screen and (max-width: 768px) {
  .el-date-range-picker .el-picker-panel__body {
    min-width: 355px !important;
  }
  .el-date-range-picker {
    width: 95% !important;
  }
  .el-date-range-picker__content .el-date-range-picker__header div{
    margin-left: 25px!important;
    margin-right: 25px!important;
    font-size: 14px!important;
  }
.el-date-table td{
  padding: 0!important;
}
.el-time-panel{
  width: 85px!important;
}
.el-time-spinner__item{
  height: 26px!important;
    line-height: 26px!important;
}
.el-input__icon{
  line-height: 30px!important;
}
.el-date-editor .el-range-separator{
      line-height: 25px!important;
}
}

/* 确保Element UI组件也使用rem单位 */
.el-button {
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
}

.el-input__inner,
.el-select__inner {
  font-size: 0.875rem;
  height: 2rem;
}

.el-form-item__label {
  padding-right: 0.5rem!important;
  box-sizing: border-box!important;
  font-size: 0.875rem;
}

.el-form-item {
  margin-bottom: 1rem;
}

/* 全局浅色细滚动条（WebKit：Chrome / Edge / Safari） */
::-webkit-scrollbar {
  width: 0.25rem;
  height: 0.25rem;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(144, 147, 153, 0.3);
  border-radius: 0.125rem;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(144, 147, 153, 0.5);
}
.el-range-separator {
  width: 10% !important;
}

/* 禁用表单：保持白底深色字便于阅读，仅禁止编辑（光标 not-allowed） */
.el-input.is-disabled .el-input__inner,
.el-textarea.is-disabled .el-textarea__inner {
  background-color: #ffffff !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  -webkit-text-fill-color: #606266 !important;
  cursor: not-allowed !important;
  opacity: 1 !important;
}

.el-input.is-disabled .el-input__inner::-webkit-input-placeholder,
.el-textarea.is-disabled .el-textarea__inner::-webkit-input-placeholder {
  color: #c0c4cc;
}

.el-input.is-disabled .el-input__icon {
  cursor: not-allowed;
}

.el-range-editor.is-disabled,
.el-range-editor.is-disabled:hover {
  background-color: #ffffff !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  cursor: not-allowed !important;
}

.el-range-editor.is-disabled input {
  background-color: transparent !important;
  color: #606266 !important;
  -webkit-text-fill-color: #606266 !important;
  cursor: not-allowed !important;
  opacity: 1 !important;
}

.el-range-editor.is-disabled .el-range-separator,
.el-range-editor.is-disabled .el-range__close-icon,
.el-range-editor.is-disabled .el-range__icon {
  color: #606266 !important;
  cursor: not-allowed !important;
}

.el-select .el-input.is-disabled .el-input__inner,
.el-cascader .el-input.is-disabled .el-input__inner {
  background-color: #ffffff !important;
  color: #606266 !important;
  cursor: not-allowed !important;
}

.el-select .el-input.is-disabled .el-select__caret,
.el-cascader .el-input.is-disabled .el-input__icon {
  color: #c0c4cc;
  cursor: not-allowed;
}

.el-input-group.is-disabled > .el-input-group__append,
.el-input-group.is-disabled > .el-input-group__prepend,
.el-input-group__append .el-button.is-disabled,
.el-input-group__prepend .el-button.is-disabled,
.el-input-group__append .el-button.is-disabled:hover,
.el-input-group__prepend .el-button.is-disabled:hover {
  background-color: #ffffff !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  cursor: not-allowed !important;
}
</style>
